/**
 * Created by v-grfore on 14/03/2017.
 */
export class Helpers {

    public static formatCurrency(currencyValue: number, currencySymbol: string, decimals: number =0): string {
        if (!currencyValue) {currencyValue=0;}
        return currencySymbol + `${(currencyValue).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    }

    public static formatWork(workValue: number, workUnit: string): string {
        if (!workValue) {workValue=0;}
        return `${(workValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ` + workUnit;
    }
}


// WEBPACK FOOTER //
// ./src/Helpers.ts